import React from 'react';

import isEmpty from 'lodash/isEmpty';

import { Grid, Button, Card, makeStyles, View } from '@gogame/components';
import { withFormFieldGroupFormField } from '@gogame/form';
import { useChildComponent } from '@gogame/hooks-ts';

import { GENERAL, NAME } from 'scenes/SmartRules/SmartRuleForm/General';
import {
  ADVERTISING_TARGET,
  DYNAMIC_TARGET,
} from 'scenes/SmartRules/SmartRuleForm/constants';
import { DynamicAdvertisingTargetDetails } from 'scenes/SmartRules/components/DynamicAdvertisingTargetDetails';
import { loadPopulationDiffs } from 'scenes/SmartRules/sources/fields';

import { PopulationCustomizeForm } from './PopulationCustomizeForm';

const useStyles = makeStyles(() => ({
  root: {
    padding: '16px',
  },
}));

export const PopulationCustomize = withFormFieldGroupFormField({
  name: DYNAMIC_TARGET,
})(({ name, formik }) => {
  const [childComponent, openChildComponent] = useChildComponent();
  const classes = useStyles();

  const {
    /* eslint-disable-next-line */
    [GENERAL]: { [NAME]: nameOmit, ...general },
    [ADVERTISING_TARGET]: target,
    [DYNAMIC_TARGET]: dynamicConditionsTarget,
  } = formik.values;

  const handleClickCustomizePopulation = React.useCallback(() => {
    openChildComponent(PopulationCustomizeForm, {
      initialValues: dynamicConditionsTarget || {
        general,
        target,
      },
      onSubmit: (e) => {
        formik.setFieldValue(name, e);
      },
    });
  }, [dynamicConditionsTarget, general, target]);

  const [targetDiffs, setAdvertisingTargetDiffs] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (!dynamicConditionsTarget) {
      return;
    }
    setLoading(true);
    loadPopulationDiffs({
      target: {
        ...general,
        ...target,
      },
      dynamicTarget: {
        ...dynamicConditionsTarget[GENERAL],
        ...dynamicConditionsTarget[ADVERTISING_TARGET],
      },
    }).then((data) => {
      setLoading(false);
      setAdvertisingTargetDiffs(data);
    });
  }, [JSON.stringify(general), target, dynamicConditionsTarget]);

  return (
    <View loading={loading}>
      <Grid container spacing={3}>
        {!isEmpty(targetDiffs) && typeof targetDiffs !== 'string' ? (
          <Grid item xs={12}>
            <Card elevation={6} fullHeight={true} className={classes.root}>
              <DynamicAdvertisingTargetDetails data={targetDiffs} />
            </Card>
          </Grid>
        ) : null}
        <Grid item xs={12}>
          <Button add onClick={handleClickCustomizePopulation}>
            Customize Population
          </Button>
        </Grid>
        {childComponent}
      </Grid>
    </View>
  );
});
